jQuery(function () {
  // Anima el menu movil

  // $('#menu-toggle').on('change', function () {
  //   var self = $(this);
  //   if (self.is(':checked')) {
  //     $('.mobile-menu').show(100, function () {
  //       $('.overlay').show(500);
  //       $('.mobile-menu').css({ transform: 'translateX(0)' });
  //     });
  //   } else {
  //     $('.mobile-menu').css({ transform: 'translateX(110%)' });
  //     $('.overlay').hide(500);
  //     setTimeout(function () {
  //       $('.mobile-menu').hide();
  //     }, 550);
  //   }
  // });

  var menuAbierto = false;
  $(".menu-movil").on("click", function () {
    $(this).toggleClass("close");
    if (!menuAbierto) {
      $(".menu-wrapper").toggleClass("close");
      setTimeout(function () {
        $(".menu-container").toggleClass("close");
      }, 350);
    } else {
      $(".menu-container").toggleClass("close");
      setTimeout(function () {
        $(".menu-wrapper").toggleClass("close");
      }, 250);
    }

    $("body").toggleClass("blocked");
    menuAbierto = !menuAbierto;
  });

  // La lupa en tablet, abra el buscador del menú
  $("#lupa-tablet").click(function () {
    $("#menu-toggle").click();
    $("#nav-search-movil").focus();
  });

  // Enseña y oculta elementos del footer

  $(".toggle span").each(function () {
    $(this).click(function () {
      $(this).parent().next().slideToggle();
      $(this).toggleClass("open close");
    });
  });

  // FAQs ficha

  if ($(".faq-single").length) {
    $(".faq-single").each(function () {
      $(this).on("click", function () {
        $(this).toggleClass("faq-open");
        $(this).find(".faq-desc").slideToggle();
      });
    });
  }

  // Anima search del header

  $("#search-icon").on("click", function () {
    $(this).toggleClass("animate");
    $(".search-bar input").toggleClass("active");
    if (window.matchMedia("(max-width: 1399px)").matches) {
      $(".phone-link").toggleClass("telefon-open");
    }
  });

  // Activa el submenu del nav

  setTimeout(function () {
    $("ul.dropdown").css({ display: "grid" });
  }, 0.1);

  // Abrir buscador
  $(".search-btn").on("click", function () {
    var palabra = $("#nav-search").val();
    var palabraMovil = $("#nav-search-movil").val();
    if (
      (palabra != null && palabra != "") ||
      (palabraMovil != null && palabraMovil != "")
    ) {
      if (palabra != null && palabra != "")
        var palabraFinal = htmlspecialchars(palabra);
      else var palabraFinal = htmlspecialchars(palabraMovil);

      $(".container-modal-buscador").addClass("d-none").html("");

      jQuery.ajax({
        type: "POST",
        async: true,
        url: rutajs + "lib/ajax.php",
        data: "fn=getCursosBuscador&palabra=" + palabraFinal,
        success: function (data) {
          var returnedData = JSON.parse(data);
          var numResultados = returnedData.length;
          var htmlResultados = "";
          if (numResultados == 0) {
            htmlResultados =
              "" +
              '<h5 class="modal-titulo">No se han encontrado resultados para <span>' +
              palabraFinal +
              "</span></h5>";
          } else {
            if (numResultados == 1) {
              htmlResultados =
                "" +
                '<h5 class="modal-titulo">Encontrado <span id="numero-resultado">' +
                numResultados +
                '</span> resultado para \'<span id="tag-resultado">' +
                palabraFinal +
                "</span>'</h5>";
            } else {
              htmlResultados =
                "" +
                '<h5 class="modal-titulo">Encontrados <span id="numero-resultado">' +
                numResultados +
                '</span> resultados para \'<span id="tag-resultado">' +
                palabraFinal +
                "</span>'</h5>";
            }
            htmlResultados += "" + '<ul class="lista-resultados">';

            $.each(returnedData, function (key, value) {
              htmlResultados +=
                "" +
                '<li><a id="" class="title-curso" href="' +
                rutaweb +
                "/" +
                value["sUrlAmigable"] +
                '" title="' +
                value["sNombre"] +
                '" alt="' +
                value["sNombre"] +
                '" >' +
                value["sNombre"] +
                '<img src="/web/images/icons/i-chevron-menu.svg" alt="Flecha menu"/></a></li>';
            });

            htmlResultados += "</ul>";
          }
          $(".container-modal-buscador")
            .removeClass("d-none")
            .html(htmlResultados);
          $(".overlay-modal").show(20);
          $("#modal-buscador").addClass("active").removeClass("inactive");

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "search",
            customer_id: v_client_id,
            query: palabraFinal,
            resultados: numResultados,
            template: v_template,
            specialization: getTipoCurso(),
            category: v_page_category,
            subcategory: v_page_subcategory,
            course: v_page_name,
            modality: v_modality,
            academy: v_academy,
            search_bar_position: "HEADER",
          });
        },
      });
    }
  });

  // Cerrar buscador
  $("#search-modal-close").on("click", function () {
    if ($("#modal-buscador").hasClass("active")) {
      $("#modal-buscador").addClass("inactive").removeClass("active");
      $(".overlay-modal").hide(20);
      // $('body, html').removeClass('blocked');
    }
  });

  $(".formBuscador").submit(function (event) {
    event.preventDefault();
    $(".search-btn").click();
  });

  //Activa el boton de busqueda del nav
  // $('#search-icon').click(function () {
  //   if ($('.formBuscador').hasClass('search-active')) {
  //     $('.formBuscador')
  //       .removeClass('search-active')
  //       .addClass('search-close')
  //       .focus();
  //   } else {
  //     $('.formPhone')
  //       .removeClass('search-active')
  //       .addClass('search-close')
  //       .focus();
  //     $('.phone-link').hide();

  //     $('.formBuscador')
  //       .removeClass('search-close')
  //       .addClass('search-active')
  //       .focus();
  //   }
  // });

  $("#frmCupon").on("change keypress textInput input", function () {
    if (v_unica_start == 1) enviarEventoFormulario(2);
    v_unica_start = 2;
  });
});

function empty(mixed_var) {
  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, "", "0"];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === "object") {
    for (key in mixed_var) {
      // TODO: should we check for own properties only?
      //if (mixed_var.hasOwnProperty(key)) {
      return false;
      //}
    }
    return true;
  }

  return false;
}

function getComboMD(tipo, required, padre, clase, idForm) {
  if (typeof idForm === 'undefined') idForm = '';
  clase = "form-control";

  jQuery.ajax({
    type: "POST",
    async: false,
    url: rutajs + "lib/ajax.php",
    data:
      "fn=getComboMD&tipo=" +
      tipo +
      "&required=" +
      required +
      "&padre=" +
      padre +
      "&class=" +
      clase,
    success: function (data) {
      $(idForm + "#cont-" + tipo).html(data);
      $(idForm + "#" + tipo + "id").html(data);

      if (tipo == "pais") {
        jQuery(idForm + "#cont-" + tipo + " select").attr(
          "onchange",
          "chkPais($(this).val(), '" + idForm + "')"
        );
        jQuery(
          idForm + "#cont-" + tipo + ' select option[value="' + idpais + '"]:first'
        ).prop("selected", true);
        configurarCamposCupon(idpais, idForm);
        configurarTelefono(idpais, prefijotelefonico, patterntelefonico, idForm);
      }
    },
  });
}

function setForwardUrl(form_id, baseUrl, idEstudio, idPais) {
  idEstudio = idEstudio || null;
  idPais = idPais || 90;
  if (idEstudio == null) {
    idEstudio = $("#" + form_id + " #form_cupon_idcurso").val();
  }
  telefono = $("#" + form_id + " #form_cupon_cupon_telefono").val();
  transaction_id = $("#" + form_id + " #form_cupon_cupon_transaction_id").val();
  adsid = $("#" + form_id + " #form_cupon_cupon_adsid").val();

  if (compruebaTelefonoCaracteres(form_id, "form_cupon_cupon_telefono"))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $("#btnInformacion").attr("disabled", true);
  $("#btnInformacion").html(htmlSpinner);

  if (baseUrl == null) {
    baseUrl = rutaweb + rutajs;
  }

  $("#" + form_id + " #forward_url").val(
    baseUrl +
      "gracias?idCursoReal=" +
      idEstudio +
      "&telefono=" +
      telefono +
      "&pais=" +
      idPais +
      "&transaction_id=" +
      transaction_id +
      "&adsid=" +
      adsid
  );

  enviarEventoFormulario(0);
  enviarEventoFormulario(3);
  return true;
}

function goTo(id, errorForm = "") {
  $("html, body").animate({ scrollTop: $("#" + id).offset().top }, "slow");

  if (!empty(errorForm)) enviarEventoFormulario(4);
}

function chkDataCurso($select, idForm = "#frmCupon ") {
  var $selectedOption = $select.find('option:selected');
  var nombre = $selectedOption.text();
  var categoria = $selectedOption.data('categoria');
  var codigoCurso = $selectedOption.data('codigocurso');
  var idCursoReal = $selectedOption.val();

  $(idForm + '#form_cupon_categoria').val(categoria);
  $(idForm + '#form_cupon_nombre_curso').val(nombre);
  $(idForm + '#form_cupon_idcurso_select').val(codigoCurso);
  $(idForm + '#form_cupon_idcurso_real').val(idCursoReal);

  $select.find('option').removeAttr('selected');
  $selectedOption.attr('selected', 'selected');
}

function chkPais(idpais, idForm = "#frmCupon ") {
  idForm = !empty(idForm) ? idForm : '#frmCupon ';
  configurarCamposCupon(idpais, idForm);

  if (!$(idForm + '#prefTelf').hasClass('no-change')) {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCodigosPaises&idpais=" + idpais,
      success: function (data) {
        data = JSON.parse(data);

        configurarTelefono(idpais, data.sCodigoTelefonico, data.sTelefPattern, idForm);
      },
    });
  }
}

function chkPrefijo(sCodigoTelefonico, sCodPais, sTelefPattern, idForm = "#frmCupon ") {
  if (!$(idForm + "#prefTelf").hasClass("no-change"))
    $(idForm + "#prefTelf").addClass("no-change");

  configurarTelefono(sCodPais, sCodigoTelefonico, sTelefPattern, idForm);
}

function configurarCamposCupon(idpais, idForm = "#frmCupon ") {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoCodigoPostal = "form_cupon_cupon_codigopostal";
  /***/ idCampoProvincia = "provinciaid";
  /***/
  /* ********************************************* */

  if (idpais == 90 || idpais == "ES") {
    getComboMD("provincia", "true", idpais, '', idForm);

    $(idForm + '#' + idCampoCodigoPostal).attr('required', true);
    $(idForm + '#' + idCampoCodigoPostal).show();
    $(idForm + '.' + idCampoCodigoPostal).show();
    $(idForm + '#' + idCampoProvincia).attr('required', true);
    $(idForm + '#' + idCampoProvincia).show();
    $(idForm + '.' + idCampoProvincia).show();

    $(idForm + "#requeridos_codigo_postal").val("codigopostal"); //Para que sea obligatorio el campo código postal                $('#provinciaid').attr('required',true);
    $(idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia

    seleccionaProvincia(localStorage.numerocentrolocal);
  } else if (idpais == 249 || idpais == 61) {
    getComboMD("provincia", "true", idpais, '', idForm);

    $(idForm + '#' + idCampoProvincia).attr('required', true);
    $(idForm + '#' + idCampoProvincia).show();
    $(idForm + '.' + idCampoProvincia).show();
    $(idForm + '#' + idCampoCodigoPostal).attr('required', false);
    $(idForm + '#' + idCampoCodigoPostal).val(''); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#' + idCampoCodigoPostal).hide();
    $(idForm + '.' + idCampoCodigoPostal).hide();

    $(idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $(idForm + "#requeridos_provincia").val("provinciaid"); //Para que sea obligatorio el campo provincia
  } else {
    $(idForm + '#' + idCampoProvincia).attr('required', false);
    $(idForm + '#' + idCampoProvincia).hide();
    $(idForm + '.' + idCampoProvincia).hide();
    $(idForm + '#' + idCampoProvincia).val('');
    $(idForm + '#' + idCampoCodigoPostal).attr('required', false);
    $(idForm + '#' + idCampoCodigoPostal).val(''); //Para que NO sea obligatorio el campo código postal
    $(idForm + '#' + idCampoCodigoPostal).hide();
    $(idForm + '.' + idCampoCodigoPostal).hide();

    $(idForm + "#requeridos_codigo_postal").val(""); //Para que NO sea obligatorio el campo código postal
    $(idForm + "#requeridos_provincia").val(""); //Para que NO sea obligatorio el campo provincia
  }
}

function configurarTelefono(idpais, codigoTelefonico, pattern, idForm = "#frmCupon ") {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoTelefono = "form_cupon_cupon_telefono";
  /***/
  /* ********************************************* */

  $(idForm + "#prefTelf").find(".prefijo-box").html(codigoTelefonico);

  if (empty(pattern)) {
    $(idForm + "#" + idCampoTelefono).removeAttr("pattern");
  } else {
    $(idForm + "#" + idCampoTelefono).attr("pattern", pattern);
  }

  if (idpais == 90 || idpais == "ES") {
    maxlengthTelefono = 9;
    minlengthTelefono = 9;

    $(idForm + "#" + idCampoTelefono).attr("maxlength", maxlengthTelefono);
    $(idForm + "#" + idCampoTelefono).attr("minlength", minlengthTelefono);
  } else {
    maxlengthTelefono = 25;
    const [min, max] = Array.from(pattern.matchAll(/\d+/g));

    $(idForm + "#" + idCampoTelefono).attr("maxlength", max[0]);
    $(idForm + "#" + idCampoTelefono).attr("minlength", min[0]);
  }

  $(idForm + "#form_cupon_prefijo").val(codigoTelefonico);
}

function restringirCampoNumerico(idCampo) {
  $("#" + idCampo).on("input", function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, "")
        );
      }
    });
  });
}

function seleccionaProvincia(valueProvincia) {
  if (valueProvincia != "") {
    $(
      "#cont-provincia #provinciaid option[value='" + valueProvincia + "']"
    ).prop("selected", true);
  }
}

function enviarEvento() {
  var valorCategoria = $("#CategoriaCuponGeneral option:selected").html();
  var valorCurso = $("#form_cupon_idcurso option:selected").html();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_send",
    step: "1",
    formacion: "curso",
    categoria: valorCategoria, // Aquí la categoría de la elección anterior.
    curso: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  });

  enviarEventoFormulario(2);
}

function enviarEventoFormulario(tipoEvento = 0) {
  var valorTipo = getTipoCurso();
  var v_form_subcategory = "undefined";

  var valorTipoCupon = $("#tipo_cupon").val();
  if (typeof valorTipoCupon === "undefined") {
    var valorTipoCupon = "PDP";
  }

  var valorCategoria = (v_form_category = $(
    "#CategoriaCuponGeneral option:selected"
  ).html()); // Este valor está en el cupón del modal
  if (typeof valorCategoria === "undefined") {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCategoria = (v_form_category = $("#form_cupon_categoria").val());
    if (typeof valorCategoria === "undefined") {
      // Si estoy en un listado lo cojo del select del curso
      var valorCategoria = (v_form_category = $(
        "#form_cupon_idcurso option:selected"
      ).attr("data-categoria"));
    }
  }
  var valorCurso = $("#form_cupon_idcurso option:selected").html();
  if (typeof valorCurso === "undefined") {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCurso = $("#form_cupon_nombre_curso").val();
  }
  var valorPais = $("#paisid option:selected").html();
  if (typeof valorPais === "undefined") {
    var valorPais = $("#form_cupon_cupon_paisid option:selected").html();
  }
  if (valorPais == "-- Pais --") valorPais = "";
  var valorProvincia = $("#provinciaid option:selected").html();
  if (valorProvincia == "-- Provincia --" || valorProvincia == "-- Estado --")
    valorProvincia = "";
  var valorCP = $("#form_cupon_cupon_codigopostal").val();
  var valorNacionalidad = $("#nacionalidad option:selected").html();
  if (valorNacionalidad == "-- Nacionalidad --") valorNacionalidad = "";
  var valorEdad = $("#edad option:selected").html();
  if (valorEdad == "-- Edad --") valorEdad = "";
  var valorEstudios = $("#estudiosid option:selected").html();
  if (valorEstudios == "-- Nivel de estudios --") valorEstudios = "";
  if (valorEstudios == "-- Nivel Estudios --") valorEstudios = "";

  // Recogemos valor de Nombre, Email, Teléfono y los hasheamos
  var valorNombre = $("#form_cupon_cupon_nombre").val();
  var valorEmail = $("#form_cupon_cupon_email").val();
  var valorTelefono = $("#form_cupon_cupon_telefono").val();
  if (empty(valorEmail)) {
    valorEmail = "undefined";
    valorHashEmail = "undefined";
    valorHashStandardEmail = 'undefined';
  } else {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data: "fn=encryptSHABase64&cadena=" + valorEmail,
      success: function (data) {
        data = JSON.parse(data);

        valorHashEmail = data.cadena;
      },
      error: function () {
        valorHashEmail = "undefined";
      },
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardEmail = data.cadena;
      },
      error: function() {
        valorHashStandardEmail = 'undefined';
      }
    });
  }
  if (empty(valorTelefono)) {
    valorTelefono = "undefined";
    valorHashTelefono = "undefined";
    valorHashStandardTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data: "fn=encryptSHABase64&cadena=" + valorTelefono,
      success: function (data) {
        data = JSON.parse(data);

        valorHashTelefono = data.cadena;
      },
      error: function () {
        valorHashTelefono = "undefined";
      },
    });

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data : 'fn=encryptSHA&cadena='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashStandardTelefono = data.cadena;
      },
      error: function() {
        valorHashStandardTelefono = 'undefined';
      }
    });
  }

  if (empty(valorCP)) {
    valorCP = "undefined";
    valorHashCP = "undefined";
    valorHashStandardCP = "undefined";
  } else {
    // solo le quitamos espacios y guiones al valor hasheado
    var valorCP_2 = valorCP;

    if (valorCP_2.includes(" ")) {
      valorCP_2 = valorCP_2.replace(/\s+/g, ""); // Elimina todos los espacios
    }
    if (valorCP_2.includes("-")) {
      valorCP_2 = valorCP_2.replace(/-/g, ""); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: "POST",
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data: "fn=encryptSHABase64&cadena=" + valorCP_2,
      success: function (data) {
        data = JSON.parse(data);

        valorHashCP = data.cadena;
      },
      error: function () {
        valorHashCP = "undefined";
      },
    });
    
    jQuery.ajax({
      type: "POST",
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data: "fn=encryptSHA&cadena=" + valorCP_2,
      success: function (data) {
        data = JSON.parse(data);

        valorHashStandardCP = data.cadena;
      },
      error: function () {
        valorHashStandardCP = "undefined";
      },
    });
  }

  if (empty(valorNombre)) {
    valorNombre = "undefined";
    valorHashNombre = "undefined";
    valorHashStandardNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: "POST",
      async: false,
      url: cdn_rutacdn + "ajax.php",
      data: "fn=quitaMayusculasYacentos&cadena=" + valorNombre,
      success: function (data) {
        valorNombreSinAcentos = data;
      },
      error: function () {
        valorNombreSinAcentos = "undefined";
      },
    });

    if (valorNombreSinAcentos != "undefined" && valorNombreSinAcentos.trim().length !== 0) {
      jQuery.ajax({
        type: "POST",
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data: "fn=encryptSHABase64&cadena=" + valorNombreSinAcentos,
        success: function (data) {
          data = JSON.parse(data);

          valorHashNombre = data.cadena;
        },
        error: function () {
          valorHashNombre = "undefined";
        },
      });

      jQuery.ajax({
        type: 'POST',
        async: false,
        url: cdn_rutacdn + "ajax.php",
        data : 'fn=encryptSHA&cadena='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashStandardNombre = data.cadena;
        },
        error: function() {
          valorHashStandardNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = "undefined";
      valorHashStandardNombre = 'undefined';
    }
  }

  var valorTransaction = $("#transactionIdWeb").val();

  if (tipoEvento == 0) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_send",
      step: "2",
      formacion: valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
      categoria: valorCategoria, // Aquí la categoría de la elección anterior.
      curso: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
      pais: valorPais, // Queremos saber de qué país es.
      provincia: valorProvincia, // Queremos saber de qué provincia es.
      cp: valorCP, // Queremos saber el código postal.
      nacionalidad: valorNacionalidad, // Queremos saber de qué nacionalidad es.
      edad: valorEdad, // Queremos saber la edad escogida.
      nivel_estudios: valorEstudios, // Queremos el nivel de estudios que ha indicado
    });
  } else if (tipoEvento == 1) {
    // view_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
    });
  } else if (tipoEvento == 2) {
    // form_start
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_start",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory: v_form_subcategory,
      form_course: valorCurso,
      form_modality: "Semipresencial",
    });
  } else if (tipoEvento == 3) {
    // generate_lead
    var valorCursoId = $("#form_cupon_idcurso_real").val();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory: v_form_subcategory,
      form_course: valorCurso,
      edu_pid: valorCursoId,
      form_modality: "Semipresencial",
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      postal_hash: valorHashCP,
      nombre: valorHashNombre,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad,
      hashed_name_edu: valorHashStandardNombre,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_mail_edu: valorHashStandardEmail,
      hashed_cp_edu: valorHashStandardCP
    });
  } else if (tipoEvento == 4) {
    // error_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory: v_form_subcategory,
      form_course: valorCurso,
      form_modality: "Semipresencial",
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad,
      hashed_phone_edu: valorHashStandardTelefono,
      hashed_mail_edu: valorHashStandardEmail,
      error_field: errorForm,
    });
  }
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $("#" + form_id + " #" + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $("#" + form_id + " #" + telefono).val("");
  inputTelefono.reportValidity();

  return true;
}

function enviarEventoViewForm() {
  enviarEventoFormulario(1);
}

function contieneClasesEnArray(clases) {
  var contiene = false;

  if (!empty(clases)) {
    var aClases = clases.split(" ");

    $.each(aClases, function (key, value) {
      if (jQuery.inArray(value, aClasesMakingScience) != -1) contiene = true;
    });
  }

  return contiene;
}

$(document).on("click", ".cta_menu_header", function (e) {
  if (
    !empty(
      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .prev(".cta_menu_header")
        .text()
        .trim()
    )
  ) {
    var v_menu_category = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .prev(".cta_menu_header")
      .text()
      .trim();
    var v_menu_subcategory_1 = $(this)
      .parent()
      .parent()
      .prev(".cta_menu_header")
      .text()
      .trim();
    var v_menu_subcategory_2 = $(this).text().trim();
  } else if (
    !empty($(this).parent().parent().prev(".cta_menu_header").text().trim())
  ) {
    var v_menu_category = $(this)
      .parent()
      .parent()
      .prev(".cta_menu_header")
      .text()
      .trim();
    var v_menu_subcategory_1 = $(this).text().trim();
    var v_menu_subcategory_2 = "";
  } else {
    var v_menu_category = $(this).text().trim();
    var v_menu_subcategory_1 = "";
    var v_menu_subcategory_2 = "";
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_header",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    menu_category: v_menu_category.toUpperCase(),
    menu_subcategory_1: v_menu_subcategory_1.toUpperCase(),
    menu_subcategory_2: v_menu_subcategory_2.toUpperCase(),
  });
});

$(document).on("click", ".cta_menu_footer", function (e) {
  if (!empty($(this).parent().prev(".cta_menu_footer").attr("data-texto"))) {
    var v_menu_category = $(this)
      .parent()
      .prev(".cta_menu_footer")
      .attr("data-texto");
    var v_menu_subcategory_1 = $(this).text().trim();
  } else if (
    !empty($(this).parent().parent().prev(".cta_menu_footer").text().trim())
  ) {
    var v_menu_category = $(this)
      .parent()
      .parent()
      .prev(".cta_menu_footer")
      .text()
      .trim();
    var v_menu_subcategory_1 = $(this).text().trim();
  } else {
    var v_menu_category = $(this).text().trim();
    var v_menu_subcategory_1 = "";
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_footer",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    menu_category: v_menu_category.toUpperCase(),
    menu_subcategory_1: v_menu_subcategory_1.toUpperCase(),
  });
});

$(document).on("click", "a, button", function (e) {
  if (!contieneClasesEnArray($(this).attr("class"))) {
    var v_cta_copy = "";

    if (!empty($(this).text().trim())) v_cta_copy = $(this).text().trim();
    else if (!empty($(this).attr("title"))) v_cta_copy = $(this).attr("title");
    else if (!empty($(this).attr("alt"))) v_cta_copy = $(this).attr("alt");

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_content",
      customer_id: v_client_id,
      template: v_template,
      specialization: getTipoCurso(),
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      cta_name: "GENERIC",
      cta_copy: v_cta_copy.toUpperCase(),
    });
  }
});

$(document).on("click", ".carousel", function (e) {
  var v_carousel_name = $(this).parent().attr("data-name");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "carousel",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    carousel_name: v_carousel_name.toUpperCase(),
  });
});

$(document).on("click", ".ctc", function (e) {
  var v_ctc_position = $(this).attr("data-position");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "ctc",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    ctc_position: v_ctc_position.toUpperCase(),
  });
});

$(document).on("click", ".cta_cmb", function (e) {
  var v_cta_copy = $(this).text().trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_cmb",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    cta_name: "CMB",
    cta_copy: v_cta_copy.toUpperCase(),
  });
});

$(document).on("click", ".cta_mapa", function (e) {
  var v_map_icon = $(this).attr("data-icon");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_mapa",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    map_icon: v_map_icon.toUpperCase(),
  });
});

$(document).on("click", ".share", function (e) {
  var v_share_position = $(this).attr("data-position");
  var v_platform = $(this).attr("data-platform");

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "share",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    share_position: v_share_position.toUpperCase(),
    platform: v_platform.toUpperCase(),
  });
});

function enviarEventoScrollPage(v_scroll_percentage) {
  var porcentajeActual = $("footer").attr("data-porcentaje");
  var sendEvent = false;

  if (v_scroll_percentage >= 90 && porcentajeActual < 90) {
    sendEvent = true;
    v_scroll_percentage = 90;
  } else if (v_scroll_percentage >= 75 && porcentajeActual < 75) {
    sendEvent = true;
    v_scroll_percentage = 75;
  } else if (v_scroll_percentage >= 50 && porcentajeActual < 50) {
    sendEvent = true;
    v_scroll_percentage = 50;
  } else if (v_scroll_percentage >= 25 && porcentajeActual < 25) {
    sendEvent = true;
    v_scroll_percentage = 25;
  }

  if (sendEvent) {
    $("footer").attr("data-porcentaje", v_scroll_percentage);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "scroll_custom",
      customer_id: v_client_id,
      template: v_template,
      specialization: getTipoCurso(),
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      scroll_percentage: v_scroll_percentage,
    });
  }
}

function scrollPage() {
  scroll = $(window).scrollTop();
  heightFooter = $("footer").outerHeight();
  totalPage = $("footer").offset().top;

  enviarEventoScrollPage((scroll * 100) / (totalPage - heightFooter));
}

$(window).scroll(function (event) {
  scrollPage();
});

$(window).resize(function (event) {
  scrollPage();
});

function getTipoCurso() {
  var valorTipo = $("#form_cupon_tipo_curso").val();

  if (typeof valorTipo === "undefined") var valorTipo = "";

  return valorTipo;
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
    $(spinnerContenedor).appendTo(elementoContenedor);
    $(".spinner-contenedor").html(htmlSpinner);
  } else {
    $(".spinner-contenedor").remove();
  }
}

function htmlspecialchars(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function cambiarTab(event, tabNumber) {
  event.preventDefault();

  // Remover clase active de todos los tabs y contenidos
  $(".tab-contenido").removeClass("active");
  $(".tabs-wrapper ul li").removeClass("active");

  // Activar el tab y contenido seleccionado
  $("#tab-delegacion-" + tabNumber).addClass("active");
  $(".tab-active-delegacion-" + tabNumber).addClass("active");
}

// Nuevo cupón modal
$(document).on('click', '.solicita-informacion', function (e) {
  var esLlamada = $(this).is('#customEnlaceLlamadaFueraHorario');
  var eventoWeb = $(this).data('evento');

  cargaModal(e, null, null, eventoWeb, esLlamada);
});

function cargaModal(e = null, categoria = null, curso = null, eventoWeb = undefined, esLlamada = false) {
  if (e && typeof e.stopPropagation === 'function') {
    e.preventDefault();
    e.stopPropagation();
  }

  if(!empty(categoria))
    catCuponPost = categoria;
  else
    catCuponPost = catCupon;

  if(!empty(curso))
    curCuponPost = curso;
  else
    curCuponPost = curCupon;

  if(eventoWeb == undefined)
    eventoWeb = 'Solicita_info';

  if(!empty(curCuponPost)) {
    mostrarOcultarSpinner(true, '.overlay-modal');

    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);
          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");

          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }

          $("#cm-form #datosCupon").html("");

          jQuery.ajax({
            type: "POST",
            async: true,
            url: rutajs + "lib/ajax.php",
            data: 'fn=getCupon&idCursoComercial=' + curCuponPost +
              '&isModal=' +
              '-modal' +
              '&iw=' +
              cdn_idweb +
              '&rcdn=' +
              cdn_rutacdn +
              '&pCupon=' +
              encodeURIComponent(pCupon) +
              '&rw=' +
              cdn_rutaweb +
              '&lang=' +
              idioma_cupon,
            success: function (data) {
              if (data != '') {
                $('#cm-form #datosCupon').append(data);

                $(".slick-form-modal").slick("slickGoTo", 3);
                $(".cm-form-main-wrapper .pasos span").text("2");
                $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
                $("#cm-form").addClass("limit-width");

                if(hideBtnBackModal) {
                  $(".cm-form-main-wrapper .btn-back").hide();
                  $(".cm-form-main-wrapper .button-row").css('display', 'block');
                }

                enviarEvento('formularioCuponGeneral');
              }

              if(typeof loadRecaptchaLibrary === 'function')
                loadRecaptchaLibrary();
            },
          }).done(function(){
            $("#cm-form").addClass("visible");
            mostrarOcultarSpinner(false, '.overlay-modal');

            setTimeout(function () {
              $('.slick-form-modal').slick('setPosition');
            }, 500);
          });
        }
      },
    })
  } else {
    mostrarOcultarSpinner(true, '#cm-form');

    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getModalCupon&esl=' +
        esLlamada +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&eventoWeb=' +
        eventoWeb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {
        if (data != '' && jQuery('#cm-form').length == 0) {
          $('body').append(data);

          $(".overlay-modal").fadeIn(500);
          $("body").addClass("blocked");
          $("#cm-form").addClass("visible");

          $(".slick-form-modal").slick({
            arrows: false,
            draggable: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: false,
            adaptiveHeight: true,
          });

          $(".back-1").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 0);
            $("#cm-form").removeClass("limit-width");
          });
          $(".btn-back").on("click", function () {
            $(".slick-form-modal").slick("slickGoTo", 1);
            $(".cm-form-main-wrapper .pasos span").text("1");
            $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("Infórmate gratis y sin compromiso");
            $("#cm-form").removeClass("limit-width");
          });

          // Si tengo definido el client_id (variable de session_id) y abro el modal, hago un push al datalayer
          if (v_client_id != undefined) {
            dataLayer = typeof dataLayer !== "undefined" ? dataLayer : [];

            dataLayer.push({
              event: "open_generic",
              client_id: v_client_id,
            });

            setTimeout(function () {
              valorTipoCupon = "Generic";
              //enviarEventoViewForm();
            }, 200);
          }
        }
      },
    }).done(function(){
      if (aCatCupon != '' && aCatCupon != undefined) {
        $('.selector-modal-categoria').closest('li').hide();

        $.each(aCatCupon, function(index, value) {
          $('#categoria-modal-' + value).closest('li').show();
        });
      }

      if (catCuponPost != '' && catCuponPost != undefined)
        $('#categoria-modal-' + catCuponPost).click();
    });
  }
}

function cargaCursos(element) {
  var idCategoria = element.data('categoria-id');
  var sNombre = element.data('name');

  if (idCategoria != "") {
    mostrarOcultarSpinner(true, '#cm-form');

    $("#stepCurso").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: "fn=getCursosGrupo&valorCategoria=" + idCategoria,
      success: function (data) {
        data = JSON.parse(data);

        if (!empty(data.aCursos)) {
          var html = '';
          var idCategoria = null;
          var nGrupo = "";
          var style = "";
          var currentGroupHtml = "";

          $.each(data.aCursos, function (index, value) {

            var showCourse = (aCurCupon == '' || aCurCupon == undefined || $.inArray(value.idCursoComercial, aCurCupon) !== -1);
            if (showCourse) {
              if (value.idCategoria != idCategoria) {
                if (idCategoria !== null) {
                  html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idCategoria + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
                }
                idCategoria = value.idCategoria;
                nGrupo = (value.sGrupo != undefined) ? value.sGrupo : value.categoriaNombre;
                currentGroupHtml = '';
              }
              currentGroupHtml += '<li><a href="javascript:void(0)" id="curso-' + value.idCursoComercial + '" class="chip primary-stroke size-s tipo-formacion-general tipo-formacion-' + value.idCategoria + '" data-curso-id="' + value.idCursoComercial + '" data-name="' + value.sNombre + '" onclick="cargaCupon($(this), \'-modal\')" ' + style + '>' + value.sNombre + '</a></li>';
            }
          });

          if (idCategoria !== null) {
            html += '<div class="step-listado-curso tipo-formacion-general tipo-formacion-' + idCategoria + '" ' + style + '><h3>' + nGrupo + '</h3><ul class="listado-col">' + currentGroupHtml + '</ul></div>';
          }

          $("#stepCurso").html(html);
          $(".step-categoria-nombre").html(sNombre + '<svg class="i"><use xlink:href="#cm-lapiz"></use></svg>');
          $(".slick-form-modal").slick("slickGoTo", 1);
          $("#cm-form").removeClass("limit-width");
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
      setTimeout(function () {
        setTimeout(function () {
          if (curCuponPost != "" && curCuponPost != undefined)
            $('#curso-' + curCuponPost).click();
        }, 1000);
      }, 1000);

      mostrarOcultarSpinner(false, '#cm-form');
    });
  }
}

function cargaCupon(element, isModal = '') {
  var idCursoComercial = element.data('curso-id');
  var sNombre = element.data('name');

  if (idCursoComercial != "") {
    mostrarOcultarSpinner(true, '#cm-form');

    $("#cm-form #datosCupon").html("");

    jQuery.ajax({
      type: "POST",
      async: true,
      url: rutajs + "lib/ajax.php",
      data: 'fn=getCupon&idCursoComercial=' + idCursoComercial +
        '&isModal=' +
        isModal +
        '&iw=' +
        cdn_idweb +
        '&rcdn=' +
        cdn_rutacdn +
        '&pCupon=' +
        encodeURIComponent(pCupon) +
        '&rw=' +
        cdn_rutaweb +
        '&lang=' +
        idioma_cupon,
      success: function (data) {

        if (data != '') {
          $('#cm-form #datosCupon').append(data);
          $(".slick-form-modal").slick("slickGoTo", 2);
          $(".cm-form-main-wrapper .pasos span").text("2");
          $(".cm-form-main-wrapper .cm-form-subcabecera-title").text("¿Dónde contactamos contigo?");
          $("#cm-form").addClass("limit-width");

          if(hideBtnBackModal) {
            $(".cm-form-main-wrapper .btn-back").hide();
            $(".cm-form-main-wrapper .button-row").css('display', 'block');
          }

          enviarEvento('formularioCuponGeneral');
        }

        if(typeof loadRecaptchaLibrary === 'function')
          loadRecaptchaLibrary();
      },
    }).done(function(){
        mostrarOcultarSpinner(false, '#cm-form');
    });
  }
}